// src/components/Sections/FAQSection/FAQSection.jsx

import React from 'react';
import './FAQSection.scss';
import { faqItems } from './FAQContent';

export default function FAQSection() {
  return (
    <section id="faq" className="section">
      <div className="container faq">
        <p className="eyebrow">Before you join</p>
        <h2>Questions worth answering.</h2>
        <p className="faq__intro">
          What the membership does, what it costs, and what we are still building.
        </p>

        {faqItems.map((item, index) => (
          <details className="faq__item" key={item.question} open={index === 0 ? true : undefined}>
            <summary className="faq__q">{item.question}</summary>
            <p className="faq__a">{item.answer}</p>
          </details>
        ))}

        <p className="faq__contact">
          Something else? <a href="#contact">Ask us directly.</a>
        </p>
      </div>
    </section>
  );
}
